import {
  CREATE_LISTING_FAILED,
  CREATE_LISTING_SUCCESS,
  CREATE_LISTING_START,
  DELETE_LISTING_FAILED,
  DELETE_LISTING_SUCCESS,
  DELETE_LISTING_START,
  UPDATE_LISTING_FAILED,
  UPDATE_LISTING_SUCCESS,
  UPDATE_LISTING_START,
  DUPLICATE_LISTING_START,
  DUPLICATE_LISTING_SUCCESS,
  DUPLICATE_LISTING_FAILED,
  CLEAR_LISTING_ERROR,
  UPDATE_LISTING_INFO_FAILED,
  UPDATE_LISTING_INFO_SUCCESS,
  UPDATE_LISTING_INFO_START,
  CLEAR_LISTING_INFO_ERROR,
  LISTING_ERROR,
  FETCH_LISTING_START,
  FETCH_LISTING_SUCCESS,
  FETCH_LISTING_FAILED,
  FETCH_LISTING_BY_BRANCH_START,
  FETCH_LISTING_BY_BRANCH_SUCCESS,
  FETCH_LISTING_BY_BRANCH_FAILED,
  FETCH_ACTIVE_LISTING_BY_BRANCH_SUCCESS,
  FETCH_INACTIVE_LISTING_BY_BRANCH_SUCCESS,
  GENERATE_PDF_START,
  GENERATE_PDF_SUCCESS,
  GENERATE_PDF_FAILED,
  UPDATE_PULLFORWARD_LISTING_SUCCESS,
} from "../store/types";

// ----------------------
// Helpers
// ----------------------
const updateListingInArray = (arr, updated) => {
  if (!Array.isArray(arr)) return arr;
  return arr.map((item) => (item.id === updated.id ? { ...item, ...updated } : item));
};

const removeListingFromArray = (arr, id) => {
  if (!Array.isArray(arr)) return arr;
  return arr.filter((item) => item.id !== id);
};

// ----------------------
// Initial State
// ----------------------
const INITIAL_STATE = {
  listing: [],
  listingsByBranch: [],
  activeListingsByBranch: [],
  inactiveListingsByBranch: [],
  currentListing: null,
  pdfLinks: null,
  completed: false,
  loading: false,
  success: false,
  listingInfo: {
    loading: false,
    completed: false,
    success: false,
  },
  error: {
    flag: false,
    msg: null,
  },
};

// ----------------------
// Reducer
// ----------------------
export const Listingreducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    // ----------------------
    // CREATE
    // ----------------------
    case CREATE_LISTING_START:
      return {
        ...state,
        loading: true,
      };

    case CREATE_LISTING_SUCCESS:
      return {
        ...state,
        loading: false,
        completed: true,
        success: true,
        listing: [...state.listing, action.payload],
        activeListingsByBranch: [...state.activeListingsByBranch, action.payload],
        currentListing: action.payload,
      };

    case DUPLICATE_LISTING_START:
      return {
        ...state,
        loading: true,
      };
    case DUPLICATE_LISTING_SUCCESS:
      return {
        ...state,
        loading: false,
        completed: true,
        success: true,
        currentListing: action.payload,
        listing: [...state.listing, action.payload],
        activeListingsByBranch: [...state.activeListingsByBranch, action.payload],
      };


    case CREATE_LISTING_FAILED:
      return {
        ...state,
        currentListing: null,
        loading: false,
        completed: true,
        success: false,
        error: {
          flag: true,
          msg: action.payload,
        },
      };

    // ----------------------
    // UPDATE
    // ----------------------
    case UPDATE_LISTING_START:
      return {
        ...state,
        loading: true,
      };

    case UPDATE_LISTING_SUCCESS: {
      const updated = action.payload;
      return {
        ...state,
        loading: false,
        completed: true,
        success: true,
        listing: updateListingInArray(state.listing, updated),
        listingsByBranch: updateListingInArray(state.listingsByBranch, updated),
        activeListingsByBranch: updateListingInArray(state.activeListingsByBranch, updated),
        inactiveListingsByBranch: updateListingInArray(state.inactiveListingsByBranch, updated),
        currentListing: updated,
      };
    }

    case UPDATE_PULLFORWARD_LISTING_SUCCESS: {
      const updated = action.payload;
      return {
        ...state,
        loading: false,
        listing: updateListingInArray(state.listing, updated),
        listingsByBranch: updateListingInArray(state.listingsByBranch, updated),
        activeListingsByBranch: updateListingInArray(state.activeListingsByBranch, updated),
        inactiveListingsByBranch: updateListingInArray(state.inactiveListingsByBranch, updated),
        pullforward: {
          flag: true,
          msg: action.msg,
        },
      };
    }

    case UPDATE_LISTING_FAILED:
      return {
        ...state,
        loading: false,
        completed: true,
        success: false,
        error: {
          flag: true,
          msg: action.payload,
        },
      };

    // ----------------------
    // FETCH
    // ----------------------
    case FETCH_LISTING_START:
      return {
        ...state,
        loading: true,
      };

    case FETCH_LISTING_SUCCESS:
      return {
        ...state,
        loading: false,
        listing: action.payload,
      };

    case FETCH_LISTING_FAILED:
      return {
        ...state,
        loading: false,
        error: {
          flag: true,
          msg: action.payload,
        },
      };

    case FETCH_LISTING_BY_BRANCH_START:
      return {
        ...state,
        loading: true,
      };

    case FETCH_LISTING_BY_BRANCH_SUCCESS:
      return {
        ...state,
        loading: false,
        listingsByBranch: action.payload,
        activeListingsByBranch: action.payload.activeListings,
        inactiveListingsByBranch: action.payload.inactiveListings,
      };

    case FETCH_LISTING_BY_BRANCH_FAILED:
      return {
        ...state,
        loading: false,
        error: {
          flag: true,
          msg: action.payload,
        },
      };

    case FETCH_ACTIVE_LISTING_BY_BRANCH_SUCCESS:
      return {
        ...state,
        loading: false,
        activeListingsByBranch: action.payload,
      };

    case FETCH_INACTIVE_LISTING_BY_BRANCH_SUCCESS:
      return {
        ...state,
        loading: false,
        inactiveListingsByBranch: action.payload,
      };

    // ----------------------
    // DELETE
    // ----------------------
    case DELETE_LISTING_START:
      return {
        ...state,
        loading: true,
      };

    case DELETE_LISTING_SUCCESS: {
      const id = action.payload;
      return {
        ...state,
        listing: removeListingFromArray(state.listing, id),
        listingsByBranch: removeListingFromArray(state.listingsByBranch, id),
        activeListingsByBranch: removeListingFromArray(state.activeListingsByBranch, id),
        inactiveListingsByBranch: removeListingFromArray(state.inactiveListingsByBranch, id),
        loading: false,
      };
    }

    case DELETE_LISTING_FAILED:
      return {
        ...state,
        loading: false,
        error: {
          flag: true,
          msg: action.payload,
        },
      };

    // ----------------------
    // ERROR HANDLING
    // ----------------------
    case LISTING_ERROR:
      return {
        ...state,
        currentListing: null,
        loading: false,
        completed: true,
        success: false,
        error: {
          flag: true,
          msg: action.payload,
        },
      };

    case CLEAR_LISTING_ERROR:
      return {
        ...state,
        completed: false,
        loading: false,
        success: false,
        pdfLinks: null,
        error: {
          flag: false,
          msg: null,
        },
      };

    case UPDATE_LISTING_INFO_START:
      return {
        ...state,
        listingInfo: {
          loading: true,
          completed: false,
          success: false,
        },
      };

    case UPDATE_LISTING_INFO_FAILED:
      return {
        ...state,
        listingInfo: {
          loading: false,
          completed: true,
          success: false,
        },
      };

    case UPDATE_LISTING_INFO_SUCCESS: {
      const updated = action.payload;
      return {
        ...state,
        loading: false,
        completed: true,
        success: true,
        listingInfo: {
          loading: false,
          completed: true,
          success: true,
        },
        listing: updateListingInArray(state.listing, updated),
        listingsByBranch: updateListingInArray(state.listingsByBranch, updated),
        activeListingsByBranch: updateListingInArray(state.activeListingsByBranch, updated),
        inactiveListingsByBranch: updateListingInArray(state.inactiveListingsByBranch, updated),
        currentListing: updated,
      };
    }

    case CLEAR_LISTING_INFO_ERROR:
      return {
        ...state,
        listingInfo: {
          loading: false,
          completed: false,
          success: false,
        },
        error: {
          flag: false,
          msg: null,
        },
      };

    // ----------------------
    // PDF GENERATION
    // ----------------------
    case GENERATE_PDF_START:
      return {
        ...state,
        loading: true,
      };

    case GENERATE_PDF_SUCCESS:
      return {
        ...state,
        pdfLinks: action.payload,
      };

    case GENERATE_PDF_FAILED:
      return {
        ...state,
        loading: false,
        error: {
          flag: true,
          msg: action.payload,
        },
      };

    // ----------------------
    // DEFAULT
    // ----------------------
    default:
      return state;
  }
};
